import api from './api';

// 설문지 조회
export const getSurvey = async () => {
  const response = await api.get('/survey/');
  return response.data;
};

// 설문지 자동 저장
export const autoSaveSurvey = async (answers, additionalData = {}) => {
  const response = await api.post('/survey/auto-save/', { 
    answers,
    additionalData
  });
  return response.data;
};

// 설문지 제출
export const submitSurvey = async (answers, additionalData = {}) => {
  const response = await api.post('/survey/submit/', { 
    answers,
    additionalData
  });
  return response.data;
};

